import React, { useState, useLayoutEffect } from 'react'
import api from '../api'

import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Input, Space, Table, Alert, Typography, message, Statistic, Modal, Tooltip, Select, Tag, Image } from 'antd'

import { ProCard, CheckCard } from '@ant-design/pro-components'

// import Alipay from 'https://i.n2yun.com.cn/cdn/n2_web/20240904/static/media/alipay.fb7960d688e287342a6f.png'
import Wxpay from '../../images/wxpay.png'

const { Title, Text } = Typography




function formatNumber(num) {
    const number = Number(num);
    if (number % 1 !== 0) {
        // 有小数部分
        return number.toFixed(1);
    } else {
        // 整数
        return number.toString();
    }
}




//  控制台-产品中心
function Over(props) {
    const [data, setData] = useState({ money: 0, over: [], amount: 0 })
    const [value, setValue] = useState(31)
    const [timevalue, setTimeValue] = useState(1)
    const [payment, setPayment] = useState(false)
    const [notify, setNotify] = useState(true)
    const [qrpayment, setQrPayment] = useState(null)
    const [pay_type, setPay_Type] = useState('alipay')
    const [paymentData, setPaymentData] = useState({})
    const [rosdata, setRosData] = useState({ Data: [], buy: false, plans_discount: { 1: 1.0, 3: 1.0, 6: 1.0, 12: 1.0 }, productID: false })
    const [rosprice, setRosPrice] = useState({ new: 10, default: 10 })

    useLayoutEffect(() => {
        getRos()
    }, [])

    async function getRos() {
        let name = 'productData'
        if (localStorage.getItem(name)) {
            setRosData({ ...rosdata, ...JSON.parse(localStorage.getItem(name)) })
        }

        api.get('/api/v2/user/get', {
            params: {
                name: 'ros_plans',
            }
        })
            .then((res) => {
                if (res.data.code === 200) {
                    let Data = res.data.data.data.Data

                    localStorage.setItem(name, JSON.stringify({ ...Data.ros, productID: Data.productID }))

                    setData({ ...data, money: Data.money })
                    setRosData({ ...rosdata, ...Data.ros, productID: Data.productID })
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }


    function onChange(value) {
        if (!value) {
            return
        }

        for (let i = 0; i < rosdata.Data.length; i++) {
            const element = rosdata.Data[i];
            if (element.id === value) {
                // setRosPrice(element.price)


                let price = element.price * timevalue

                if (rosdata.plans_discount[timevalue]) {
                    price = price * rosdata.plans_discount[timevalue]
                }

                // price = price * 0.85
                // price = parseInt(price)

                setRosPrice({ new: price, default: parseInt(element.price * timevalue) })
            }
        }
        setValue(value)
    }

    function onTimeChange(value_) {
        for (let i = 0; i < rosdata.Data.length; i++) {
            const element = rosdata.Data[i];
            if (element.id === value) {
                let price = element.price * value_

                if (rosdata.plans_discount[value_]) {
                    price = price * rosdata.plans_discount[value_]
                }

                // price = price * 0.85
                // price = parseInt(price)

                setRosPrice({ new: price, default: parseInt(element.price * value_) })
            }
        }

        setTimeValue(value_)
    }

    //  唤醒支付
    // function pay() {
    //     if (!props.state.user.phone_number) {
    //         message.error('根据用户协议, 你需要绑定手机号才能使用此功能!')
    //         const link = document.createElement('a')
    //         link.href = '/bindingphone'
    //         link.click()
    //         return
    //     }

    //     if (!value || value !== 'alipay') {
    //         message.error('目前仅支持支付宝, 暂不支持其他的支付方式')
    //         return
    //     }

    //     api.post('/api/v2/pay_v2/alipay', {
    //         type: 'create_order',
    //         amount: data.amount,
    //     })
    //         .then((res) => {
    //             if (res.data.code === 200) {
    //                 const link = document.createElement('a')
    //                 link.href = res.data.data.data.url
    //                 link.target = '_blank';  // 关键修改点
    //                 link.rel = 'noopener noreferrer'; // 安全建议

    //                 message.success('正在跳转支付宝支付页面, 支付完成后勿关闭页面...')

    //                 setTimeout(() => {
    //                     link.click();
    //                     setPaymentData({ out_trade_no: res.data.data.data.out_trade_no })
    //                     setPayment(true)
    //                 }, 1500);
    //             } else {
    //                 message.error(res.data.data.text)
    //             }
    //         })
    //         .catch((error) => {
    //             message.error('网络异常,无法连接服务器')
    //         })
    // }

    function vPay(wx) {
        api.post('/api/v2/pay_v2/alipay', {
            type: 'get_order',
            out_trade_no: paymentData.out_trade_no,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    if (wx) {
                        setQrPayment(null)
                    }
                    setPayment(false)
                    message.success('检测到已成功支付!')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }


    //  购买产品
    function Buy() {
        // api.post('/api/v2/pay_v2', {
        //     type: 'add_users_order',
        //     tname: 'ros',
        //     name: 'ros',
        //     plan_id: value,
        //     duration: timevalue,
        // })
        //     .then((res) => {
        //         if (res.data.code === 200) {
        //             message.success('已完成下单, 开通进度可在订单中心查询!')
        //         } else {
        //             message.error(res.data.data.text)
        //         }
        //     })
        //     .catch((error) => {
        //         message.error('网络异常,无法连接服务器')
        //     })



        //  临时渠道
        api.post('/api/v2/pay_v2', {
            type: 'add_users_order_v2',
            tname: 'ros',
            name: 'ros',
            plan_id: value,
            duration: timevalue,
            pay_type: pay_type,
        })
            .then((res) => {
                if (res.data.code === 200) {

                    if (res.data.data.data.QRcode_url) {
                        message.success('已获取支付二维码')
                        setQrPayment(res.data.data.data.QRcode_url)
                        setPaymentData({ out_trade_no: res.data.data.data.out_trade_no })
                        // setPayment(true)
                        return
                    }

                    const link = document.createElement('a')
                    link.href = res.data.data.data.url
                    link.target = '_blank';  // 关键修改点
                    link.rel = 'noopener noreferrer'; // 安全建议

                    message.success('正在跳转支付宝支付页面, 支付完成后勿关闭页面...')

                    setTimeout(() => {
                        link.click();
                        setPaymentData({ out_trade_no: res.data.data.data.out_trade_no })
                        setPayment(true)
                    }, 1500);
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }

    return (
        <div>

            {/* <Alert
                message="首购优惠"
                description="在2025年12月31日之前首次购买存储块产品即享85折优惠, 续费恢复原价!"
                showIcon
                style={{ marginBottom: 20 }}
            /> */}

            <div style={{ minWidth: '100%' }}>
                {/* <ProCard title="余额" style={{ maxWidth: 300, marginBottom: 20 }} bordered headerBordered>
                    <Statistic value={data.money} suffix="¥" />
                </ProCard> */}

                <ProCard title={<Text>购买说明</Text>} style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', maxWidth: '100%', marginBottom: 20 }} bordered>
                    - 如产品成功下单并处于锁定或已成功开通情况下, 不再支持退款。
                    <br />
                    {/* - 已成功下单的产品信息可在 <Text strong>订单中心</Text> 进行查询开通状态, 目前已支持自动化开通产品, 如出现无法开通时仍需要等待人工在24小时内完成开通。 */}
                    - 已成功下单的产品信息可在 <Text strong>订单中心</Text> 进行查询开通状态, 目前因维护原因, 自助开通已关闭, 需要联系站务进行人工购买。
                    <br />
                    - 存储块产品如完成开通后可前往 <a href="/app/nzcos" rel="noopener noreferrer">开放平台/NZ云存储 V2</a> 进行即可使用。
                    <br />
                    {/* 关于存储块产品是额外支持绑定自己的域名, 但需要完成网站备案后才能正常使用, 如有需要可联系下方QQ进行处理。
                    <br /> */}
                    - 如果在购买时遇到问题, 请联系站务进行处理。
                    <br />
                    特别说明: 如申请退款将会可能产生对应的渠道手续费费用, 如需要请申请退款联系QQ: 198513272 (备注来意)。

                    {/* 进行充值即表明您已知 <a href="/useragreement" target="_blank" rel="noopener noreferrer">《用户协议》</a> 里的内容并遵循。 */}
                </ProCard>

                {/* <ProCard title="积分" style={{ maxWidth: 300, marginBottom: 20 }} bordered headerBordered>
                    <Statistic value={data.money} suffix="" />
                </ProCard>
                <ProCard title="积分说明" style={{ maxWidth: 300 }} bordered>
                    积分可用于在网站进行资源下载与购买等场景, 新用户注册可获得xx积分。
                </ProCard> */}
            </div>

            <ProCard title={<><Tag color="processing">New</Tag> <Text>存储块产品套餐</Text>  {rosdata.productID ? <Tag color="warning">已购买, 限购1份</Tag> : ''}</>} style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', maxWidth: '100%', float: 'left' }} bordered headerBordered>
                <CheckCard.Group style={{ width: '100%' }} value={value} onChange={onChange}>
                    {rosdata.Data.map((i, k) => {
                        return (
                            <CheckCard
                                title={<Text>{i.chinese}</Text>}
                                description={<>
                                    <Text>价格: <Text style={{ color: '#FFA24A' }}>{i.price}</Text> 元/月</Text>
                                </>}
                                size='small'
                                value={i.id}
                                style={{ backgroundColor: '#141414' }}
                            />
                        )
                    })}
                </CheckCard.Group>
            </ProCard>

            {/* 
            <ProCard title={<><Tag color="processing">New</Tag> 技术支持</>} style={{ maxWidth: '100%', float: 'left', marginTop: 20 }} bordered headerBordered>
                <CheckCard.Group style={{ width: '100%' }} defaultValue={1}>
                    <CheckCard
                        title={'普通服务 - 必选'}
                        description={<>
                            价格: 18元
                        </>}
                        size='small'
                        value={1}
                    />
                    <CheckCard
                        title={'标准服务 - 支持定制'}
                        description={<>
                            价格: 48元
                        </>}
                        size='small'
                        value={11}
                    />
                </CheckCard.Group>
            </ProCard>
 */}


            {/* <ProCard title={<><Tag color="processing">New</Tag> Nzadmin 管理面板产品</>} style={{ maxWidth: '100%', float: 'left', marginTop: 20 }} bordered headerBordered>
                <CheckCard.Group style={{ width: '100%' }} defaultValue={1}>
                    <CheckCard
                        title={'普通版永久授权'}
                        description={<>
                            价格: 9.8元
                        </>}
                        size='small'
                        value={1}
                    />
                    <CheckCard
                        title={'标准版月付'}
                        description={<>
                            价格: 24元
                        </>}
                        size='small'
                        value={11}
                    />
                    <CheckCard
                        title={'高级版月付'}
                        description={<>
                            价格: 48元
                        </>}
                        size='small'
                        value={111}
                    />
                </CheckCard.Group>
            </ProCard>
 */}


            <ProCard title={<Text>支付方式</Text>} style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', maxWidth: 500, float: 'left', marginTop: 20 }} bordered headerBordered>
                <CheckCard.Group style={{ width: '100%' }} value={pay_type} onChange={(value) => {
                    if (value) {
                        setPay_Type(value)
                    }
                }}>
                    <CheckCard
                        title="支付宝"
                        size='small'
                        cover={
                            <img
                                alt="alipay"
                                src={'https://cdn.n2yun.com.cn/bed/2025/06/16/300_868_白底 .png'}
                                style={{
                                    width: 160,
                                    height: 50
                                }}
                            />
                        }
                        value="alipay"
                        style={{ backgroundColor: '#141414' }}
                    />
                    <CheckCard
                        title="微信支付"
                        size='small'
                        cover={
                            <img
                                alt="wxpay"
                                src={Wxpay}
                                style={{
                                    width: 120,
                                    height: 50
                                }}
                            />
                        }
                        value="wxpay"
                        style={{ backgroundColor: '#141414' }}
                    />
                </CheckCard.Group>
            </ProCard>



            {/* <Modal
                title="重要通知"
                centered
                open={notify}
                onOk={() => setNotify(false)}
                onCancel={() => setNotify(false)}
            >
                - 目前已支持自动化开通产品, 如出现无法开通时仍需要等待人工在24小时内完成开通。
                <br />
                - 如果在购买时遇到问题, 可联系QQ: 198513272 (备注来意)
            </Modal> */}

            <Modal
                title="支付结果"
                centered
                open={payment}
                onOk={() => vPay()}
                onCancel={() => setPayment(false)}
            >
                已经完成支付? 点击下方确定进行检查支付状态确保该订单及时创建!
            </Modal>

            <Modal
                title="微信扫码支付"
                centered
                open={qrpayment}
                onOk={() => { vPay(true) }}
                onCancel={() => { setQrPayment(null) }}
            >
                <Space direction="vertical" >
                    <Text>备注: 支付完成后请稍等几秒, 系统自动处理订单, 如超过数分钟仍没处理, 请与站务联系处理。</Text>
                    <Image
                        width={200}
                        src={qrpayment}
                    />
                </Space>
            </Modal>


            <div className='product_cost'>
                <ProCard title={<Text>结算</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414' }} >
                    <div style={{ marginBottom: 20 }}>
                        <Select
                            value={timevalue}
                            onChange={onTimeChange}
                            style={{ width: 120 }}
                            options={[
                                { value: 1, label: '1个月' },
                                { value: 3, label: <>3个月 {rosdata.plans_discount[3] < 0.99 ? (rosdata.plans_discount[3] * 10) + '折' : ''}</> },
                                { value: 6, label: <>半年付 {rosdata.plans_discount[6] < 0.99 ? (rosdata.plans_discount[6] * 10) + '折' : ''}</> },
                                { value: 12, label: <>年付 {rosdata.plans_discount[12] < 0.99 ? (rosdata.plans_discount[12] * 10) + '折' : ''}</> },
                            ]}
                        />
                    </div>
                    <Text>配置价格: <Text style={{ color: '#FFA24A' }} strong>{formatNumber(rosprice.new)}</Text> 元 {rosprice.default > rosprice.new ? <Text delete>原价: {rosprice.default}</Text> : <></>}</Text>
                    <Button type="primary" style={{ float: 'right' }} disabled={rosdata.productID} onClick={Buy}>购买</Button>
                </ProCard>
            </div>
        </div>
    )
}

export default Over;